import {
  AvailableWriteProviders,
  Web3KeyWriteProvider,
} from '@ankr.com/provider';

import { AVAILABLE_CHAINS } from 'modules/common';

import { BaseContractManager } from './BaseContractManager';
import { ChainsAvailableReadProvider } from './consts';
import { getProviderManager } from './GetProviderManager';
import { GetInstanceParams } from './types';

export class ContractsManager {
  private static instance?: ContractsManager;

  private readonly provider: Web3KeyWriteProvider;

  public get currentAccount(): string {
    return this.provider.currentAccount;
  }

  private constructor(provider: Web3KeyWriteProvider) {
    ContractsManager.instance = this;

    this.provider = provider;
  }

  public static disconnect(): void {
    delete ContractsManager.instance;
  }

  public getProvider(): Web3KeyWriteProvider {
    return this.provider;
  }

  public static async getInstance(
    params?: GetInstanceParams,
  ): Promise<BaseContractManager> {
    const providerManager = await getProviderManager();

    if (params) {
      const { chainId, forceRead } = params;

      const readProviderType = ChainsAvailableReadProvider[chainId];

      if (forceRead && !readProviderType) {
        throw new Error('Provider type for selected chain is not defined');
      }

      const provider = await (forceRead && readProviderType
        ? providerManager.getETHReadProvider(readProviderType)
        : providerManager.getETHWriteProvider(
            AvailableWriteProviders.ethCompatible,
          ));

      return new BaseContractManager(provider);
    }

    if (ContractsManager.instance) {
      const { instance } = ContractsManager;

      return new BaseContractManager(instance.getProvider());
    }

    const providerInstance = await getProviderManager();
    const provider = await providerInstance.getETHWriteProvider(
      AvailableWriteProviders.ethCompatible,
    );
    // eslint-disable-next-line no-new
    new ContractsManager(provider);

    const web3 = provider.getWeb3();
    const chainId = await web3.eth.getChainId();
    const isCorrectChain = AVAILABLE_CHAINS.includes(chainId);

    if (isCorrectChain && !provider.isConnected()) {
      await provider.connect();
    }

    return new BaseContractManager(provider);
  }
}
